import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightOutlined } from '@ant-design/icons';
import { getPublishedBlogPosts } from '../api/blogPostApi';
import BlogCard from './BlogCard';

// Homepage "Our Blog" section — shows the latest published posts from the
// BlogPost feature. Deliberately a separate component from the
// pre-existing (repurposed) BlogSection.js, which is left untouched.
const OurBlogSection = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLatest = async () => {
      try {
        const response = await getPublishedBlogPosts({ page: 1, limit: 3 });
        if (response?.success && Array.isArray(response.blogPosts)) {
          setPosts(response.blogPosts);
        }
      } catch (error) {
        console.error('Error fetching latest blog posts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLatest();
  }, []);

  // Hide the section entirely until there's at least one published post —
  // avoids an awkward empty section on the live homepage.
  if (!loading && posts.length === 0) return null;
  if (loading) return null;

  return (
    <section
      className="ourblog-section"
      style={{
        width: '100%',
        float: 'left',
        clear: 'both',
        padding: '90px 20px',
        background: '#fafafc',
        fontFamily: "'Rubik', sans-serif"
      }}
    >
      <style>{`
        .ourblog-cards-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }
        @media (max-width: 992px) {
          .ourblog-cards-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 640px) {
          .ourblog-cards-grid { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 768px) {
          .ourblog-section {
            padding: 50px 16px !important;
          }
          .ourblog-header {
            align-items: flex-start !important;
            margin-bottom: 32px !important;
          }
          .ourblog-title {
            font-size: 24px !important;
          }
          .ourblog-view-all {
            padding: 10px 16px !important;
            font-size: 13px !important;
            white-space: nowrap;
          }
        }
      `}</style>

      <div style={{ maxWidth: '1300px', margin: '0 auto' }}>
        {/* Header */}
        <div className="ourblog-header" style={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          marginBottom: '48px',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <div style={{ textAlign: 'left' }}>
            <span style={{
              display: 'inline-block',
              fontSize: '13px',
              fontWeight: 700,
              color: '#470172',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              marginBottom: '10px'
            }}>
              From The Blog
            </span>
            <h2 className="ourblog-title" style={{ fontSize: '40px', fontWeight: 700, color: '#111', margin: 0, letterSpacing: '-0.5px', textAlign: 'left' }}>
              Stories & Insights
            </h2>
          </div>
          <Link
            to="/blog"
            className="ourblog-view-all"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px',
              color: '#fff',
              background: '#470172',
              padding: '13px 26px',
              borderRadius: '50px',
              fontSize: '15px',
              fontWeight: 600,
              textDecoration: 'none',
              boxShadow: '0 8px 20px rgba(71,1,114,0.25)'
            }}
          >
            View All Blogs <ArrowRightOutlined />
          </Link>
        </div>

        {/* Cards Grid */}
        <div className="ourblog-cards-grid">
          {posts.map((post) => (
            <BlogCard key={post._id} post={post} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurBlogSection;
